import axios, { AxiosResponse } from "axios";

/**
 * Makes a generic API request using Axios.
 * @param path - An array representing the path segments of the API endpoint.
 * @param method - HTTP method for the request (GET, POST, PUT, PATCH, DELETE, etc.).
 * @param data - Data to be sent with the request (optional).
 * @param header - Request headers (optional).
 * @returns {Promise<{ data: any, response?: AxiosResponse, error?: any }>} - Resolves with response data or an error object.
 */
export default async function makeApiRequest(path, method = "GET", data, signal) {
  let apiUrl, options;

  if (process.env.REACT_APP_WORDPRESS_MODE === "true") {
    apiUrl = `/wp-admin/admin-ajax.php`; // WordPress AJAX URL
    const postData = data ? JSON.stringify(data) : "";
    // base64 encode the path to avoid issues with special characters
    const encodedPath = btoa(JSON.stringify(path));
    options = {
      method: "POST",
      url: apiUrl,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: `action=car_tuning_ajax_handler&path=${encodedPath}&method=${method}&data=${postData}`,
    };
  } else {
    const baseURL = `${process.env.REACT_APP_BASE_URL}/api`;
    apiUrl = `${baseURL}${path}`;
    options = {
      method,
      url: apiUrl,
      headers: {
        "X-API-Key": process.env.REACT_APP_X_API_KEY,
      },
      signal,
    };

    if (data) {
      const formData = new FormData();
      for (const key in data) {
        formData.append(key, data[key]);
      }
      options.data = formData;
    }
  }

  try {
    const response = await axios(options);
    if (response.data && response.data.data) {
      return { data: response.data.data, response };
    }
    return { data: response.data, response };
  } catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.clear();
      window.location.reload();
    }
    return { error: error.response, message: error?.message };
  }
}

